import { useI18n } from 'vue-i18n';

export function useFloor() {
  const { t, locale } = useI18n();

  function getEnglishOrdinalSuffix(num: number): string {
    const j = num % 10;
    const k = num % 100;
    if (j === 1 && k !== 11) {
      return num + 'st';
    }
    if (j === 2 && k !== 12) {
      return num + 'nd';
    }
    if (j === 3 && k !== 13) {
      return num + 'rd';
    }
    return num + 'th';
  }

  function getFloorTextByNumber(floorNumber: number): string {
    switch (floorNumber) {
    case -2:
      return t('floor.basement');
    case -1:
      return t('floor.semiBasement');
    case 0:
      return t('floor.groundFloor');
    case 1:
      return t('floor.first');
    default:
      // Utiliser l'ordinal suffix pour les autres étages. En anglais, on utilise "1st", "2nd", "3rd", et ensuite "4th", "5th", etc.
      if (locale.value.startsWith('en')) {
        return `${getEnglishOrdinalSuffix(floorNumber)} floor`;
      } else {
        return t('floor.floor', { floor: floorNumber });
      }
    }
  }

  return {
    getFloorTextByNumber,
  };
}
